var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 56,
    viewBox: "0 0 41 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0604 21.7819V47.2953H4.7196V21.7819",
    stroke: "#4B4A4A",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.980835 23.9282L20.39 7.98083L39.7992 23.9282",
    stroke: "#4B4A4A",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.30048 19.5548V11.9619H9.95844V16.5546",
    stroke: "#4B4A4A",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.721 36.5061H18.0706V47.3069H22.721V36.5061Z",
    stroke: "#4B4A4A",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4447 23.2012H26.7943V27.8516H31.4447V23.2012Z",
    stroke: "#4B4A4A",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.721 23.2012H18.0706V27.8516H22.721V23.2012Z",
    stroke: "#4B4A4A",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9857 23.2012H9.33533V27.8516H13.9857V23.2012Z",
    stroke: "#4B4A4A",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4447 36.4253H26.7943V41.0756H31.4447V36.4253Z",
    stroke: "#4B4A4A",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9857 36.4253H9.33533V41.0756H13.9857V36.4253Z",
    stroke: "#4B4A4A",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.78,
    height: 41.2762,
    fill: "white",
    transform: "translate(0 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHouse);
export default __webpack_public_path__ + "static/media/IconHouse.b5b07833f0434a788c3d88b520a103f8.svg";
export { ForwardRef as ReactComponent };